<style>
    table.tb1
    {
        border-collapse:collapse;
    }

    table.tb1 th, table.tb1 td
    {
        border: 1px solid #ccc;
    }

    table.tb1 th{
        text-align: center;
        font-weight: bold;
        padding:5px;
    }

    .canceled{
        text-decoration:line-through
    }

    .hide{
        display:none;
    }
</style>

<template>
    <div id="ScheduleSection">
        <card>
            <Tabs @on-click="changeType" :animated="false">
                <TabPane label="列表模式" name="list">
                    <div style="min-height:300px">
                        <Form ref="searchForm" :model="searchForm" inline class="searchForm" id="searchFormSection"
                              @keyup.enter.native="doSearch()">
                            <FormItem prop="daterange" label="时间范围" :label-width="60">
                                <DatePicker :value="searchForm.daterange" type="daterange" split-panels placeholder="选择时间范围"
                                            style="width: 240px"
                                            format="yyyy-MM-dd" @on-change="searchForm.daterange=$event"></DatePicker>
                            </FormItem>
                            <Form-item prop="zoneId" label="校区" :label-width="60">
                                <Select v-model="searchForm.zoneId" filterable style="width: 250px" placeholder="全部" clearable>
                                    <Option v-for="item in zoneList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                                </Select>
                            </Form-item>
                            <Form-item prop="classId" label="班级" :label-width="60">
                                <Select v-model="searchForm.classId" filterable style="width: 250px" clearable>
                                    <Option v-for="item in multiClassList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                                </Select>
                            </Form-item>
                            <Form-item prop="teacherId" label="教师" :label-width="60">
                                <Select v-model="searchForm.teacherId" filterable style="width: 250px" clearable>
                                    <Option v-for="item in teacherList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                                </Select>
                            </Form-item>
                            <Form-item prop="studentId" label="学生" :label-width="60">
                                <Select v-model="searchForm.studentId" filterable style="width: 250px" clearable>
                                    <Option v-for="item in studentList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                                </Select>
                            </Form-item>
                            <Form-item prop="courseId" label="课程" :label-width="60">
                                <Select v-model="searchForm.courseId" filterable style="width: 250px" clearable>
                                    <Option v-for="item in courseList" :value="item.id" :key="item.id">{{ item.name}}({{ item.type |
                                        courseTypeFilter }})
                                    </Option>
                                </Select>
                            </Form-item>
                            <Form-item prop="courseType" label="类别" :label-width="60">
                                <Select v-model="searchForm.courseType" style="width: 250px" clearable>
                                    <Option :value="1">一对一</Option>
                                    <Option :value="2">班课</Option>
                                </Select>
                            </Form-item>
                            <Form-item prop="state" label="状态" :label-width="60">
                                <Select v-model="searchForm.state" style="width: 250px" clearable>
                                    <Option :value="1">未开始</Option>
                                    <Option :value="2">已结束</Option>
                                    <Option :value="3">已取消</Option>
                                </Select>
                            </Form-item>
                            <Form-item prop="isAppointment" label="预约课程" :label-width="60">
                                <Checkbox v-model="searchForm.isAppointment" :true-value="true" :false-value="false"></Checkbox>
                            </Form-item>
                            <FormItem>
                                <Button type="primary" @click="doSearch" size="small">搜索</Button>
                                <Button type="primary" @click="addSchedule" size="small" style="margin-left:10px;">新增日程</Button>
                                <Button type="primary" @click="showCancelWin(2,null)" size="small" style="margin-left:10px;">批量取消</Button>
                                <Button type="primary" @click="batchDelete" size="small" style="margin-left:10px;">批量删除</Button>
                            </FormItem>
                        </Form>
                        <Table :columns="columns" :data="data" :loading="dataLoading" @on-selection-change="selectChange"></Table>
                        <Page :total="pageTotalNum" :current="pageCurrent" v-if="showPager" show-elevator show-total show-sizer
                              @on-page-size-change="pageSizeChange" @on-change="changePage" :page-size="size"></Page>
                    </div>

                </TabPane>
                <TabPane label="日历模式" name="calendar">
                    <Form ref="searchForm2" :model="searchForm2" inline class="searchForm searchFormSection"
                          @keyup.enter.native="doSearch2()">
                        <Row style="margin-bottom: 8px;">
                            <Col span="24">
                                <ButtonGroup>
                                <Button @click="preweek">《上周</Button>
                                <Button @click="thisweek">本周</Button>
                                <Button @click="nextweek">下周》</Button>
                                </ButtonGroup>
                                <span style="margin-left:8px;">
                                    {{searchForm2.daterange[0]}} 至 {{searchForm2.daterange[1]}}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form-item prop="zoneId" label="校区" :label-width="60">
                                    <Select v-model="searchForm2.zoneId" filterable style="width: 250px" placeholder="全部" clearable>
                                        <Option v-for="item in zoneList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                                    </Select>
                                </Form-item>
                                <Form-item prop="teacherId" label="教师" :label-width="60">
                                    <Select v-model="searchForm2.teacherId" filterable style="width: 250px" clearable>
                                        <Option v-for="item in teacherList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                                    </Select>
                                </Form-item>
                                <Form-item prop="studentId" label="学生" :label-width="60">
                                    <Select v-model="searchForm2.studentId" filterable style="width: 250px" clearable>
                                        <Option v-for="item in studentList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                                    </Select>
                                </Form-item>
                                <Form-item prop="courseId" label="课程" :label-width="60">
                                    <Select v-model="searchForm2.courseId" filterable style="width: 250px" clearable>
                                        <Option v-for="item in courseList" :value="item.id" :key="item.id">{{ item.name}}({{ item.type |
                                            courseTypeFilter }})
                                        </Option>
                                    </Select>
                                </Form-item>
                                <Form-item prop="courseType" label="类别" :label-width="60">
                                    <Select v-model="searchForm2.courseType" style="width: 250px" clearable>
                                        <Option :value="1">一对一</Option>
                                        <Option :value="2">班课</Option>
                                    </Select>
                                </Form-item>
                                <Form-item prop="state" label="状态" :label-width="60">
                                    <Select v-model="searchForm2.state" style="width: 250px" clearable>
                                        <Option :value="1">未开始</Option>
                                        <Option :value="2">已结束</Option>
                                        <Option :value="3">已取消</Option>
                                    </Select>
                                </Form-item>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form-item prop="isAppointment" label="预约课程" :label-width="60">
                                    <Checkbox v-model="searchForm2.isAppointment" :true-value="true" :false-value="false"></Checkbox>
                                </Form-item>
                                <FormItem>
                                    <Button type="primary" @click="doSearch2" size="small">搜索</Button>
                                    <Button type="primary" @click="addSchedule" size="small" style="margin-left:10px;">新增日程</Button>
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                    <table style="width:100%" class="tb1">
                        <tr>
                            <th></th>
                            <th v-for="calendarDate in calendarDateList" >
                                {{calendarDate|calendarDateFilter}}
                            </th>
                        </tr>
                        <tr v-for="calendarTime in calendarTimeList">
                            <td>{{calendarTime}}</td>
                            <td v-for="calendarDate in calendarDateList" >
                                <div v-if="calendarData[calendarDate+' '+calendarTime] != undefined">
                                    <div v-for="schedule in (calendarData[calendarDate+' '+calendarTime])" :key="schedule.id" >
                                        <Poptip trigger="hover" width="380" :transfer="true">
                                            <Button type="default" size="small" v-if="schedule.state == 1" >{{schedule.teacherName}}</Button>
                                            <Button type="success" size="small" v-if="schedule.state == 2">{{schedule.teacherName}}</Button>
                                            <Button type="dashed" size="small" class="canceled" v-if="schedule.state == 3" disabled>{{schedule.teacherName}}</Button>
                                            <div class="api" slot="content">
                                                {{schedule.zoneName}}<br>
                                                {{schedule.className|classNameFilter(schedule)}}<br>
                                                {{schedule.classdate}}<br>
                                                {{schedule.begin}} - {{schedule.end}}<br>
                                                {{schedule.teacherName}}<br>
                                                <Tag :color="schedule.state|stateColorFilter" >{{schedule.state|stateTxtFilter}}</Tag><br>
                                                <hr>
                                                <ButtonGroup>
                                                <Button type="primary" size="small" v-if="schedule.state == 1" @click="edtiOneTime(schedule)">编辑单次</Button>
                                                <Button type="primary" size="small" v-if="schedule.state == 1" @click="edtiRepeat(schedule)">编辑重复</Button>
                                                <Button type="primary" size="small" v-if="schedule.state == 1" @click="showCancelWin(1,schedule.id)">取消单次</Button>
                                                <Button type="primary" size="small" v-if="schedule.state == 1" @click="delOneTime(schedule)">删除单次</Button>
                                                <Button type="primary" size="small" v-if="schedule.state == 1" @click="delRepeat(schedule)">删除重复</Button>
                                                </ButtonGroup>
                                            </div>
                                        </Poptip>

                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </TabPane>
            </Tabs>
        </card>
        <schedule-form ref="ScheduleForm" v-on:close="onCloseForm"></schedule-form>
        <Modal v-model="schedule.showModal" :title="title" width="800">
            <Form :model="schedule" :label-width="100" ref="scheduleForm"
                  @keyup.enter.native="scheduleHandleSubmit()">
                <Row v-if="schedule.id == null">
                    <Col span="12">
                        <FormItem label="排课方式">
                            <RadioGroup v-model="schedule.isRepeat">
                                <Radio :label="0">
                                    <span>单次</span>
                                </Radio>
                                <Radio :label="1">
                                    <span>重复</span>
                                </Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem label="班级/一对一">
                            <Select v-model="schedule.classId" filterable :disabled="schedule.id != null" :label-in-value="true" @on-change="changeClass">
                                <Option v-for="clazz in classList"  :value="clazz.id" :key="clazz.id">【{{clazz.courseType|courseTypeFilter }}】 {{clazz.name }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="教师">
                            <Select v-model="schedule.teacherId" style="width:200px;" placeholder="选择教师">
                                <Option v-for="(item,index) in teacherList" :key="index" :value="item.id">
                                    {{item.name}}
                                </Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row v-if="schedule.isRepeat != 1 && schedule.courseType == 2">
                    <Col span="24">
                        <FormItem label="学员">
                            <Select v-model="schedule.studentId" filterable style="width: 250px" clearable>
                                <Option v-for="item in studentList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                            </Select>
                            <span style="color:blue;margin-left:15px;">只对某一学员排课，不选则对该班所有学员排课</span>
                        </FormItem>
                    </Col>
                </Row>
                <div :class="{ hide: schedule.isRepeat == 1 }">
                    <Row>
                        <Col span="12">
                            <FormItem label="上课日期">
                                <DatePicker type="date" placeholder="上课日期"
                                            format="yyyy-MM-dd" @on-change="schedule.comeDate=$event"
                                            :transfer="true" :value="schedule.comeDate"></DatePicker>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="上课时段">
                                <Select :value="schedule.comeTimeStart + ' - ' + schedule.comeTimeEnd"
                                        style="width: 200px;" @on-change="scheduleTimechange($event)">
                                    <Option v-for="(timeRange,index) in timeRangeList" :key="index"
                                            :value="timeRange.start + ' - ' + timeRange.end">{{(timeRange.start + ' - '
                                        + timeRange.end)}}
                                    </Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                </div>
                <div :class="{ hide: schedule.isRepeat == 0 }">
                    <Row>
                        <Col span="12">
                            <FormItem label="课程起止时间">
                                <DatePicker :value="schedule.daterange" type="daterange" split-panels placeholder="选择时间范围" style="width: 300px"
                                            :transfer="true" format="yyyy-MM-dd" @on-change="schedule.daterange=$event"></DatePicker>
                            </FormItem>
                        </Col>
                        <!--<Col span="12">-->
                            <!--<FormItem label="课时数">-->
                                <!--<Input v-model="schedule.hours" placeholder="不填则排满，填的话则最多排到对应课时的课"/>-->
                            <!--</FormItem>-->
                        <!--</Col>-->
                    </Row>
                    <TimeList :timeList="schedule.timeList"></TimeList>
                </div>
                <Row :class="{ hide: schedule.isRepeat == 1 }">
                    <Col span="24">
                        <FormItem label="备注">
                            <Input type="text" v-model="schedule.remark" style="width:300px;"/>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="scheduleModalCancel">取消</Button>
                <Button type="primary" size="large" @click="scheduleHandleSubmit()" :loading="schedule.saving">
                    确定
                </Button>
            </div>
        </Modal>
        <classStudentList ref="classStudentList" ></classStudentList>
        <cancelWin ref="cancelWin" @on-cancel-success="onCancelSuccess" :mode="1"></cancelWin>
    </div>
</template>
<script>
  import ScheduleForm from './form.vue';
  import moment from 'moment';
  import TimeList from '../common/timelist.vue';
  import classStudentList from '../clazz/classStudentList'
  import cancelWin from './cancelWin'
  moment.locale('zh-cn');

  export default {
    name: 'schedule_index',
    data() {
      return {
        showModel:"list",
        checkData:[],
        title:'',
        size:20,
        searchForm: {
          daterange: [
            moment(new Date()).format("YYYY-MM-DD"),
            moment(new Date()).format("YYYY-MM-DD")
          ],
          zoneId: null,
          teacherId: null,
          studentId: null,
          courseId: null,
          courseType: null,
          isAppointment: false,
          classId:null
        },
        searchForm2: {
          daterange: [],
          zoneId: null,
          teacherId: null,
          studentId: null,
          courseId: null,
          courseType: null,
          isAppointment: false,
        },
        columns: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '校区',
            key: 'zoneName'
          },
          {
            title: '上课时间',
            key: 'classdate',
            render: (h, params) => {
              return h('div', [
                h('div', params.row.classdate),
                h('div', params.row.begin + "-" + params.row.end)
              ]);
            }
          },
          // {
          //   title: '类型',
          //   render: (h, params) => {
          //     let color;
          //     let txt;
          //     if (params.row.courseType == 1) {
          //       if (params.row.appointment == 2) {
          //         color = 'volcano';
          //         txt = '试听';
          //       } else if(params.row.schedule_id){
          //         color = 'primary';
          //         txt = '普通';
          //       }else {
          //         color = 'primary';
          //         txt = '普通';
          //       }
          //     } else if (params.row.schedule_id){
          //       color = 'primary';
          //       txt = '普通';
          //     }else{
          //       color = 'success';
          //       txt = '单次';
          //     }
          //     return h('Tag',
          //       {
          //         props: {
          //           color: color
          //         },
          //       }, txt);
          //   }
          //
          // },
          {
            title: '班级/一对一',
            width: 210,
            render: (h, params) => {
              let className = '';
              if (params.row.className) {
                if (params.row.courseType == 1) {
                  className = '【一对一】' + params.row.className;
                } else {
                  className = '【班课】' + params.row.className;
                }
              } else {
                className = '【一对一】' + params.row.courseName + ' | ' + params.row.studentName
              }

              return h('div', className);
            }
          },
          {
            title: '教师',
            key: 'teacherName'
          },
          {
            title: '状态',
            key: 'state',
            render: (h, params) => {
              if (params.row.state == 1) {
                return h('Tag', {}, '未开始');
              } else if (params.row.state == 2) {
                return h('Tag',
                  {
                    props: {
                      color: 'success'
                    },
                  }, '已结束');
              } else if (params.row.state == 3) {
                return h('Tag',
                  {
                    props: {
                      color: 'warning'
                    },
                  }, '已取消');
              } else if (params.row.state == 4) {
                return h('Tag',
                  {
                    props: {
                      color: 'error'
                    },
                  }, '课时不足');
              } else {
                  return h('Tag',
                      {
                          props: {
                              color: 'error'
                          },
                      }, '系统异常');
              }

            }
          },
          {
            title: '操作',
            width: 300,

            render: (h, params) => {
              let self = this;

              let opArray = [];
              if (params.row.state == 1) {
                opArray.push(h('Button', {
                  props: {
                    size: 'small',
                    type: 'text'
                  },
                  style: {
                    // marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.edtiOneTime(params.row);
                    }
                  }
                }, '编辑单次'));
              }

              if (params.row.schedule_id !== null){
                opArray.push(h('Button', {
                  props: {
                    size: 'small',
                    type:'text'
                  },
                  style: {
                    // marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.edtiRepeat(params.row);
                    }
                  }
                }, '编辑重复'));
              }

              if (params.row.state == 1){
                opArray.push(h('Button', {
                  props: {
                    size: 'small',
                    type:'text'
                  },
                  style: {
                    // marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.showCancelWin(1,params.row.id);
                      // this.cancelOneTime(params.row);
                    }
                  }
                }, '取消单次'));
              }

              if (params.row.state == 1) {
                opArray.push(h('Button', {
                  props: {
                    size: 'small',
                    type: 'text'
                  },
                  style: {
                    // marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.delOneTime(params.row);
                    }
                  }
                }, '删除单次'));
              }

              if (params.row.schedule_id !== null){
                opArray.push(h('Button', {
                  props: {
                    size: 'small',
                    type:'text'
                  },
                  style: {
                    // marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.delRepeat(params.row);
                    }
                  }
                }, '删除重复'));
              }

              if (params.row.courseType == 2 ){
                opArray.push(h('Button', {
                  props: {
                    size: 'small',
                    type:'text'
                  },
                  style: {
                    // marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.getClassStudentList(params.row);
                    }
                  }
                }, '学员清单'));
              }

              return h('ButtonGroup', opArray);

            }
          }
        ],
        data: [],
        dataLoading: false,
        ruleInline: {},
        totalPage: 0,
        pageTotalNum: 0,
        pageCurrent: 1,
        studentList: [],
        classList: null,
        multiClassList:null,
        schedule: {
          id:null,
          showModal: false,
          classId: null,
          isRepeat: 0,
          teacherId: null,
          daterange: null,
          comeDate: null,
          comeTimeStart: null,
          comeTimeEnd: null,
          timeList: [],
          saving: false,
          hours:null,
          courseType:null,
          remark:''
        },
        calendarTimeList:['09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00'],
        calendarDateList:[],
        calendarData:{}
      }
    },
    methods: {
      changeType(name){
        this.showModel=name;
        this.getList();
      },
      onCancelSuccess(){
        this.getList();
      },
      showCancelWin(type,id){
        let ids = null;
        if (type == 2){
          let classRecordArray = this.checkData.filter(item => item.state===1 );
          let tobeDelArray = [];
          classRecordArray.forEach(ele=>{
            tobeDelArray.push(ele.id);
          });
          ids = tobeDelArray.join(",")
        }else{
          ids = id+"";
        }
        this.$refs.cancelWin.showCancelWin(ids);
      },
      selectChange(selection) {
        this.checkData = selection
      },
      getClassList() {
        if (this.classList == null) {
          this.$api.clazz.getAvailableClass().then(resp => {
            if (resp.state == 'ok'){
              this.classList = resp.data;
            }else{
              this.$Message.error(resp.msg)
            }
          });
        }
      },
      getMultiClassList() {
        if (this.multiClassList == null) {
          this.$api.clazz.getAvailableMultiClass().then(resp => {
            if (resp.state == 'ok'){
              this.multiClassList = resp.data;
            }else{
              this.$Message.error(resp.msg)
            }
          });
        }
      },
      getList() {
        let self = this;
        if (self.showModel == 'list'){
          self.dataLoading = true;
          let param = {
            page: self.pageCurrent,
            size:self.size,
            zoneId: self.searchForm.zoneId,
            teacherId: self.searchForm.teacherId,
            studentId: self.searchForm.studentId,
            classId: self.searchForm.classId,
            courseId: self.searchForm.courseId,
            courseType: self.searchForm.courseType,
            state: self.searchForm.state,
            isAppointment: self.searchForm.isAppointment ? 2 : 1,
            start: self.searchForm.daterange[0],
            end: self.searchForm.daterange[1]
          }
          if (self.searchForm.keyword) {
            param.keyword = self.searchForm.keyword;
          }
          self.$api.schedule.getList(param).then(resp => {
            self.data = resp.data.list;
            self.pageTotalNum = resp.data.totalRow;
            self.totalPage = resp.data.totalPage;
            self.pageCurrent = resp.data.pageNumber;
            self.dataLoading = false;
          });
        }else{
          let param = {
            page: 1,
            size:9999,
            zoneId: this.searchForm2.zoneId,
            teacherId: this.searchForm2.teacherId,
            studentId: this.searchForm2.studentId,
            courseId: this.searchForm2.courseId,
            courseType: this.searchForm2.courseType,
            state: this.searchForm2.state,
            isAppointment: this.searchForm2.isAppointment ? 2 : 1,
            start: this.searchForm2.daterange[0],
            end: this.searchForm2.daterange[1]
          }
          if (self.searchForm2.keyword) {
            param.keyword = self.searchForm2.keyword;
          }
          self.calendarData = {};
          self.$api.schedule.getList(param).then(resp => {
            resp.data.list.forEach((ele,idx)=>{
              let begin = null;
              self.calendarTimeList.forEach(ele2=>{
                if (ele.begin.substr(0,2) == ele2.substr(0,2)){
                  begin = ele2;
                  return false;
                }
              });
              let item = self.calendarData[ele.classdate+" "+begin];
              if (!item){
                item = [];
              }
              item.push(ele);
              self.$set(self.calendarData,ele.classdate+" "+begin,item)
            });
          });
        }

      },
      changePage(page) {
        this.pageCurrent = page;
        this.getList();
      },
      pageSizeChange (pageSize) {
        this.size=pageSize;
        this.getList();
      },
      doSearch() {
        this.pageCurrent = 1;
        this.getList();
      },
      doSearch2() {
        this.getList();
      },
      onCloseForm() {
        this.getList();
      },
      getStudentList() {
        let param = {
          page: 1,
          size: 9999
        }
        this.$api.student.list(param).then(res => {
          if (res.state == "ok") {
            this.studentList = res.data.list;
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      initScheduleModal(){
        this.schedule={
          id:null,
          showModal: false,
          classId: null,
          isRepeat: 0,
          teacherId: null,
          daterange: null,
          comeDate: null,
          comeTimeStart: null,
          comeTimeEnd: null,
          timeList: [],
          saving: false,
          hours:null,
          courseType:null,
          remark:''
        }
      },
      addSchedule() {
        this.getClassList();
        this.initScheduleModal();
        this.schedule.showModal = true;
        this.title = '新增排课';
      },
      edtiOneTime(item){
        this.getClassList();
        this.initScheduleModal();
        this.title = '编辑单次';
        this.$api.clazz.findClassRecord({id:item.id}).then(resp=>{
          if (resp.state == 'ok'){
            this.schedule.id = resp.data.id;
            this.schedule.classId = resp.data.class_id;
            this.schedule.comeDate = resp.data.classdate;
            this.schedule.comeTimeStart = resp.data.begin;
            this.schedule.comeTimeEnd = resp.data.end;
            this.schedule.teacherId = resp.data.teacher_id;
            this.schedule.isRepeat = 0;
            this.schedule.showModal = true;
          }else{
            this.$Message.error(resp.msg);
          }
        });
      },
      edtiRepeat(item){
        this.getClassList();
        this.initScheduleModal();
        this.title = '编辑重复';
        this.$api.schedule.findOne({id:item.schedule_id}).then(resp=>{
          if (resp.state == 'ok'){
            this.schedule.id = resp.data.id;
            this.schedule.classId = resp.data.class_id;
            this.schedule.teacherId = resp.data.teacher_id;
            this.schedule.daterange = [resp.data.begin_date,resp.data.end_date];
            this.schedule.hours = resp.data.hours;
            let timeList = [];
            resp.data.timeList.forEach(ele=>{
              let one = {
                weekday : ele.weekday,
                start:ele.start,
                end:ele.end
              };

              let weekdayArray = one.weekday.split(',');
              weekdayArray.forEach((ele2,idx)=>{
                weekdayArray[idx] = parseInt(ele2);
              })
              one.weekday = weekdayArray;
              timeList.push(one);
            });
            this.schedule.timeList = timeList;
            this.schedule.isRepeat = 1;
            this.schedule.showModal = true;
          }else{
            this.$Message.error(resp.msg);
          }
        });
      },
      delOneTime(item){
        let self = this;
        self.$Modal.confirm({
          title: '提示',
          content: '是否确定删除单次课程？',
          onOk: () => {
            self.$api.schedule.deleteOne({ids:item.id}).then(resp=>{
              if (resp.state == 'ok'){
                self.$Message.success("删除成功");
                self.getList();
              }else{
                self.$Message.error(resp.msg);
              }
            });
          },
          onCancel: () => {

          }
        });
      },
      cancelOneTime(item){
        let self = this;
        // self.$Modal.confirm({
        //   title: '提示',
        //   content: '是否确定取消此单次课程？（将发送取消信息给家长）',
        //   onOk: () => {
        //     self.$api.schedule.cancelOne({ids:item.id}).then(resp=>{
        //       if (resp.state == 'ok'){
        //         self.$Message.success("取消成功");
        //         self.getList();
        //       }else{
        //         self.$Message.error(resp.msg);
        //       }
        //     });
        //   },
        //   onCancel: () => {
        //
        //   }
        // });
      },
      delRepeat(item){
        let self = this;
        self.$Modal.confirm({
          title: '提示',
          content: '将删除该重复日程中所有未开始课程，是否确定删除重复课程？',
          onOk: () => {
            self.$api.schedule.deleteRepeat({ids:item.schedule_id}).then(resp=>{
              if (resp.state == 'ok'){
                self.$Message.success("删除成功");
                self.getList();
              }else{
                self.$Message.error(resp.msg);
              }
            });
          },
          onCancel: () => {

          }
        });
      },
      scheduleModalCancel() {
        this.initScheduleModal();
        this.schedule.showModal = false
      },
      checkScheduleForm(){
        if (!this.schedule.classId && !this.schedule.id){
          this.$Message.error("请选择班级/一对一");
          return false;
        }
        if (!this.schedule.teacherId){
          this.$Message.error("请选择教师");
          return false;
        }
        if (this.schedule.isRepeat){
          if (this.schedule.daterange == null){
            this.$Message.error("请选择上课日期");
            return false;
          }

          if (this.schedule.timeList.length == 0){
            this.$Message.error("请选择上课时间段");
            return false;
          }

          let checkTime = true;
          this.schedule.timeList.forEach((ele, idx) => {
            if (!ele.start) {
              checkTime = false;
              return false;
            }
            if (!ele.end) {
              checkTime = false;
              return false;
            }
            if (ele.weekday.length == 0) {
              checkTime = false;
              return false;
            }
          });

          if (!checkTime) {
            this.$Message.error("日程设置错误，星期数和时间段不能为空");
            return false;
          }
          return true;
        }else{
          if (!this.schedule.comeDate){
            this.$Message.error("请选择上课日期");
            return false;
          }
          if (!this.schedule.comeTimeStart){
            this.$Message.error("请选择时间段");
            return false;
          }
          if (!this.schedule.comeTimeEnd){
            this.$Message.error("请选择时间段");
            return false;
          }

          return true;
        }
      },
      scheduleHandleSubmit() {
        if (this.checkScheduleForm()){
          if (!this.schedule.isRepeat){
            let params = {
              id:this.schedule.id,
              classId:this.schedule.classId,
              comeDate:this.schedule.comeDate,
              comeTimeStart:this.schedule.comeTimeStart,
              comeTimeEnd:this.schedule.comeTimeEnd,
              teacherId:this.schedule.teacherId,
              studentId:this.schedule.studentId,
              remark:this.schedule.remark
            }
            this.schedule.saving = true;
            this.$api.schedule.saveOne(params).then(resp=>{
              if (resp.state == 'ok'){
                this.$Message.success("保存成功");
                this.initScheduleModal();
                this.schedule.showModal = false
                this.getList();
                this.schedule.saving = false;
              }else{
                this.$Message.error(resp.msg);
                this.schedule.saving = false;
              }
            });
          }else {
            let timeListData = [];
            this.schedule.timeList.forEach(ele => {
              ele.weekday.sort();
              let one = {...ele};
              one.weekday = one.weekday.join(',');
              timeListData.push(one);
            });
            let params = {
              'eduClassSchedule.id':this.schedule.id,
              'eduClassSchedule.class_id':this.schedule.classId,
              'eduClassSchedule.begin_date':this.schedule.daterange[0],
              'eduClassSchedule.end_date':this.schedule.daterange[1],
              'eduClassSchedule.hours':this.schedule.hours,
              'eduClassSchedule.teacher_id':this.schedule.teacherId,
              timeList:JSON.stringify(timeListData)
            }
            this.schedule.saving = true;
            this.$api.schedule.saveRepeat(params).then(resp=>{
              if (resp.state == 'ok'){
                this.$Message.success("保存成功");
                this.initScheduleModal();
                this.schedule.showModal = false
                this.getList();
                this.schedule.saving = false;
              }else{
                this.$Message.error(resp.msg);
                this.schedule.saving = false;
              }
            });
          }
        }
      },
      scheduleTimechange(value) {
        if (value){
          let timeArray = value.split('-');
          this.schedule.comeTimeStart = timeArray[0].trim();
          this.schedule.comeTimeEnd = timeArray[1].trim();
        }
      },
      batchDelete(){
        if (this.checkData.length != 0) {
          this.$Modal.confirm({
            title: '提示',
            content: '是否确定删除所选日程？',
            onOk: () => {
              let tobeDelArray = [];
              this.checkData.forEach(ele=>{
                tobeDelArray.push(ele.id);
              });
              this.$api.schedule.deleteOne({ids:tobeDelArray.join(",")}).then(resp=>{
                if (resp.state == 'ok'){
                  this.$Message.success("删除成功");
                  this.getList();
                }else{
                  this.$Message.error(resp.msg);
                }
              });
            },
            onCancel: () => {

            }
          });
        }else{
          this.$Message.error("未选中任何项");
        }
      },
      preweek(){
        let beginDate = moment(this.searchForm2.daterange[0]).subtract(7,'days').format('YYYY-MM-DD');
        let endDate = moment(this.searchForm2.daterange[1]).subtract(7,'days').format('YYYY-MM-DD');
        this.searchForm2.daterange=[
          beginDate,endDate
        ];

        this.calendarDateList = [
          beginDate,
          moment(beginDate).add(1, 'days').format('YYYY-MM-DD'),
          moment(beginDate).add(2, 'days').format('YYYY-MM-DD'),
          moment(beginDate).add(3, 'days').format('YYYY-MM-DD'),
          moment(beginDate).add(4, 'days').format('YYYY-MM-DD'),
          moment(beginDate).add(5, 'days').format('YYYY-MM-DD'),
          moment(beginDate).add(6, 'days').format('YYYY-MM-DD')
        ];

        this.getList();
      },
      thisweek(){
        let weekOfday = moment().format('E');
        let monday = moment().subtract(weekOfday-1, 'days').format('YYYY-MM-DD');
        let sunday = moment().add(7-weekOfday, 'days').format('YYYY-MM-DD');
        this.searchForm2.daterange=[
          monday,sunday
        ];
        this.calendarDateList = [
          monday,
          moment(monday).add(1, 'days').format('YYYY-MM-DD'),
          moment(monday).add(2, 'days').format('YYYY-MM-DD'),
          moment(monday).add(3, 'days').format('YYYY-MM-DD'),
          moment(monday).add(4, 'days').format('YYYY-MM-DD'),
          moment(monday).add(5, 'days').format('YYYY-MM-DD'),
          moment(monday).add(6, 'days').format('YYYY-MM-DD')
        ];
        this.getList();
      },
      nextweek(){
        let beginDate = moment(this.searchForm2.daterange[0]).add(7,'days').format('YYYY-MM-DD');
        let endDate = moment(this.searchForm2.daterange[1]).add(7,'days').format('YYYY-MM-DD');
        this.searchForm2.daterange=[
          beginDate,endDate
        ];
        this.calendarDateList = [
          beginDate,
          moment(beginDate).add(1, 'days').format('YYYY-MM-DD'),
          moment(beginDate).add(2, 'days').format('YYYY-MM-DD'),
          moment(beginDate).add(3, 'days').format('YYYY-MM-DD'),
          moment(beginDate).add(4, 'days').format('YYYY-MM-DD'),
          moment(beginDate).add(5, 'days').format('YYYY-MM-DD'),
          moment(beginDate).add(6, 'days').format('YYYY-MM-DD')
        ];
        this.getList();
      },
      getClassStudentList(row){
        this.$refs.classStudentList.showModal(row.id)
      },
      changeClass(val){
        if (val){
          if (val.label.indexOf("【班课】")>-1){
            this.schedule.courseType = 2;
          }else{
            this.schedule.courseType = 1;
          }
        }else{
          this.schedule.courseType = null;
        }

      }
    },
    mounted: function () {
      this.getMultiClassList();
      this.getStudentList();
      let weekOfday = moment().format('E');
      let monday = moment().subtract(weekOfday-1, 'days').format('YYYY-MM-DD');
      let sunday = moment().add(7-weekOfday, 'days').format('YYYY-MM-DD');
      this.calendarDateList = [
        monday,
        moment(monday).add(1, 'days').format('YYYY-MM-DD'),
        moment(monday).add(2, 'days').format('YYYY-MM-DD'),
        moment(monday).add(3, 'days').format('YYYY-MM-DD'),
        moment(monday).add(4, 'days').format('YYYY-MM-DD'),
        moment(monday).add(5, 'days').format('YYYY-MM-DD'),
        moment(monday).add(6, 'days').format('YYYY-MM-DD')
      ];

      this.searchForm2.daterange=[
        monday,
        sunday
      ];
      this.getList();
    },
    computed: {
      showPager: function () {
        return this.totalPage > 1
      },
      zoneList() {
        return this.$store.state.app.zoneList
      },
      teacherList() {
        return this.$store.state.app.teacherList
      },
      courseList() {
        return this.$store.state.app.courseList
      },
      timeRangeList() {
        return this.$store.state.app.timeList
      },
    },
    components: {
      ScheduleForm,
      TimeList,
      classStudentList,
      cancelWin
    },
    filters: {
      courseTypeFilter: function (value) {
        if (value == 1) {
          return '一对一';
        } else if (value == 2) {
          return '班课';
        } else {
          return '未知:' + value
        }
      },
      calendarDateFilter:function(value){
        return moment(value).format('dddd MM/DD')
      },
      classNameFilter:function(value,schedule){
        if (schedule.className){
          if (schedule.courseType == 1){
            return '【一对一】'+ schedule.className;
          }else{
            return '【班课】'+ schedule.className;
          }
        }else{
          return '【一对一】'+schedule.courseName + "|" + schedule.studentName;
        }

      },
      stateColorFilter:function(state){
        if (state == 1){
          return "default";
        }else if (state == 2){
          return "success";
        }else if (state == 3){
          return "default";
        }else{
          return "error"
        }
      },
      stateTxtFilter:function(state){
        if (state == 1){
          return "未开始";
        }else if (state == 2){
          return "已结束";
        }else if (state == 3){
          return "已取消";
        }else if (state == 4){
          return "课时不足";
        }else{
          return "系统异常"
        }
      },
    }
  }
</script>
